<template>
  <PageWrapper>
    <template>
      <b-form @submit.prevent="handleSubmit">
        <b-row class="margin-0 margin-top-24 form-wrapper">
          <b-col cols="12" class="padding-0">
            <Input
              :title="$lang.description"
              :label="$lang.description"
              :placeholder="$lang.description"
              :value="form.description"
              name="description"
              id="description"
              type="textarea"
              :minLength="lengthNumber3"
              :maxLength="lengthNumber256"
              :vuelidateObj="$v.form.description"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" class="padding-0">
            <EnumDropdown
              :title="$lang.adding_tag"
              :label="$lang.adding_tag"
              :placeholder="$lang.adding_tag"
              :value="form.tags"
              name="tags"
              id="tags"
              categoryName="tag_parvandeh"
              :multiple="true"
              :vuelidateObj="$v.form.tags"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
          <b-col cols="12" class="flex-end padding-0 margin-top-10">
            <Button
              type="submit"
              contentClass="justify-content-center"
              variant="primary"
              class="width-percent-20"
              :text="$lang.submit"
              :loading="loading"
            />
          </b-col>
        </b-row>
      </b-form>
    </template>
  </PageWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import { Input, EnumDropdown, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, storeDispatcher, toastAlert } from "@/shared/utils";
import { getOneParvandeh, updateParvandeh } from "@/modules/profile/services";

export default {
  mixins: [inputMixin],
  components: {
    PageWrapper,
    Input,
    EnumDropdown,
    Button,
  },
  validations() {
    return {
      form: {
        description: {},
        tags: {},
      },
    };
  },
  data() {
    return {
      parvandehCode: this.$route.params.code,
      loading: false,
      getLoading: false,
      parvandehData: null,
      form: {
        description: null,
        tags: [],
      },
    };
  },
  created() {
    this.getParvandehData();
  },
  methods: {
    pathOr,
    setMobileHeaderTitle() {
      const { fullName } = this.parvandehData;
      const title = `${this.$lang.more_options_in_parvandeh} ${fullName}`;
      storeDispatcher("mobileHeaderTitleText", title);
    },
    async getParvandehData() {
      try {
        this.getLoading = true;
        const response = await getOneParvandeh(this.parvandehCode);
        this.parvandehData = { ...response };
        this.setMobileHeaderTitle();
      } catch (error) {
        generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    async handleSubmit() {
      try {
        this.loading = true;
        const { description } = this.form;
        const tags = this.form.tags.map(({ id }) => id);
        const response = await updateParvandeh(
          this.parvandehCode,
          description,
          tags
        );
        const { message } = response;
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
